<template>
	<div class="container conclusion">
        <div class="row">
            <div class="col-12">
                <div class="headline h2 tc">
                    <span>Zusammenfassung. Fast Geschafft!</span>
                </div>
            </div>
            <div class="col-1"></div>
            <div class="col-5">
                <div class="subjects">
                  <span class="headline small-headline" v-if="this.$parent.subjectData.rows && this.$parent.subjectData.rows.length == 1">Fach <span class="edit" title="Noch mal bearbeiten" v-on:click="$emit('jumpTo', 1);"><i class="fa fa-pen"></i></span></span>
                  <span class="headline small-headline" v-if="this.$parent.subjectData.rows && this.$parent.subjectData.rows.length > 1">Fächer <span class="edit" title="Noch mal bearbeiten" v-on:click="$emit('jumpTo', 1);"><i class="fa fa-pen"></i></span></span>

                  <span v-for="(row, index) in this.$parent.subjectData.rows" :key="index"><span v-if="index != 0" >, </span>{{ row.subject }}</span><br>
                  <span>Jahrgangsstufe {{ this.$parent.subjectData.year }},  {{ this.$parent.subjectData.schooltype }}</span>
                </div>

                <div class="contactData">
                  <span class="headline small-headline" >Kontaktdaten <span class="edit" title="Noch mal bearbeiten" v-on:click="$emit('jumpTo', 3);"><i class="fa fa-pen"></i></span></span>
                  <span>{{ this.$parent.contactData.forename }} {{ this.$parent.contactData.lastname }}</span><br>
                  <span>{{ this.$parent.contactData.phone }}, {{ this.$parent.contactData.mail }}</span>
                </div>
            </div>
            <div class="col-5">
              <div class="personalData">
                <span class="headline small-headline" >Nachhilfeort <span class="edit" title="Noch mal bearbeiten" v-on:click="$emit('jumpTo', 2);"><i class="fa fa-pen"></i></span></span>
                <span>{{ this.$parent.personalData.route }} {{ this.$parent.personalData.street_number }}, {{ this.$parent.personalData.postal_code }} {{ this.$parent.personalData.locality }}</span>
              </div>

              <div class="dateData">
                  <span class="headline small-headline" >Probetermin <span class="edit" title="Noch mal bearbeiten" v-on:click="$emit('jumpTo', 4);"><i class="fa fa-pen"></i></span></span>
                  <span>Terminvorschlag 1: {{ this.$parent.dateData.dateOne | dateFormat }}</span><br>
                  <span>Terminvorschlag 2: {{ this.$parent.dateData.dateTwo | dateFormat}}</span><br>
                  <span v-if="this.$parent.dateData.dateThree" >Terminvorschlag 3: {{ this.$parent.dateData.dateThree | dateFormat }}</span>
              </div>

              <div class="privacy">
                Ich habe die <a href="https://shop.mueller-helpings.de/Datenschutz-oxid/" target="_blank" >Hinweise zum Datenschutz</a> gelesen und akzeptiere sie.
              </div>

          </div>
          <div class="col-1"></div>

        </div>
    </div>

</template>

<script>
export default {
	name: 'conclusion',
	components: {

	},

   data: function () {
    return {
      
    }
  },

  mounted() {

  },

  methods: {

  },

  filters: {
    dateFormat: function (value) {
      console.log(value);
      if (!value) return ''
      var d = new Date(value)
      return ('0'+d.getDate()).slice(-2) + '.' + ('0'+(d.getMonth()+1)).slice(-2) + '.' + d.getFullYear() + ' ' + ('0' + d.getHours()).slice(-2) + ":" + ('0' + d.getMinutes()).slice(-2);
    }
  }
}
</script>

<style lang="less">
.conclusion {
  .col-5 {
    > div {
      margin-bottom: 2rem;
    }
  }
  span.edit {
    font-size: 1rem;
    color: #4e9aa2;
    cursor: pointer;
    margin-left: 0.75rem;
  }
}

.privacy {
  background: #eee;
  padding: 1rem;
}
</style>